








import { Component, Mixins } from "vue-property-decorator";
import DecoratorMixin from '../mixin';

@Component
export default class TopicDecorator extends Mixins(DecoratorMixin) {
  //
}
